import { Outlet, Navigate } from "react-router-dom";
import { isLoggedIn } from "../utils/auth";
import ProfileProvider from "../context/ProfileContext";

const ProtectedLayout = () => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ProfileProvider>
      <Outlet />
    </ProfileProvider>
  );
};

export default ProtectedLayout;